import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";

const GET_BUSINESS_SECTORS = "get_business_sectors";

@Component
export default class BusinessSectorMixin extends Vue {
  readonly businessPath = `${BASE_API_URL}business_sectors`;

  getBusinessSectors() {
    return this.$httpGet(this.businessPath, GET_BUSINESS_SECTORS);
  }
}
